// Typelizer digest ea258b9b01f398367b1ecd0e21df6e0d
//
// DO NOT MODIFY: This file was automatically generated by Typelizer.
import type { RouteDefinition, RouteOptions } from '../runtime'
import { buildUrl } from '../runtime'

export default {
  /** POST /c/:company_id/bulk_extracts */
  create: (options?: RouteOptions): RouteDefinition<'post'> => ({
    url: buildUrl('/c/:company_id/bulk_extracts', {}, options),
    method: 'post',
  }),
}
